import { message } from 'antd';
import i18n from '../i18n';
import { deleteWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const deleteMyday = async (id: number, refetch?: () => void, withConfirmation?: boolean) => {
  if (!id) return;

  try {
    const response = await deleteWithCSRF(envApiUrl + '/mydays/', {
      headers: { id },
    });
    refetch?.();
    if (withConfirmation) {
      message.success(i18n.t('myday.mydayDeleted'));
    }
    return response.data;
  } catch (err: any) {
    console.error('deleteMyday error: ', err.response?.data?.message, err.response);
    message.error(err.response?.data?.message || i18n.t('myday.mydayDeleteFailed'));
  }
};
